export function V2ProductClientsSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-3 font-[family-name:var(--font-heading)]">
        Real products. Real clients. Real data.
      </h2>

      {/* Content area — constrained, won't push bottom bar */}
      <div className="flex-1 min-h-0 flex flex-col gap-2 max-h-[330px]">
        {/* Top row — XENI + ROBOLAB X (takes ~70%) */}
        <div className="grid grid-cols-2 gap-4 flex-[3] min-h-0">
          {/* XENI */}
          <div className="flex flex-col min-h-0">
            <div className="text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] mb-1.5">
              <span className="text-[var(--color-fg)]">XENI</span>
              <span className="text-[var(--color-fg-tertiary)] font-normal ml-1.5">— AI Paralegal Agent</span>
            </div>
            <div className="flex-1 min-h-0 rounded-sm border border-[var(--color-border)] overflow-hidden">
              <img src="/product-xeni.png" alt="Xeni product screenshot" className="w-full h-full object-cover object-left-top" />
            </div>
          </div>

          {/* ROBOLAB X */}
          <div className="flex flex-col min-h-0">
            <div className="text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] mb-1.5">
              <span className="text-[var(--color-fg)]">ROBOLAB X</span>
              <span className="text-[var(--color-fg-tertiary)] font-normal ml-1.5">— AI Learning Agent</span>
            </div>
            <div className="flex-1 min-h-0 rounded-sm border border-[var(--color-border)] overflow-hidden">
              <img src="/product-robolabx.png" alt="Robolab X product screenshot" className="w-full h-full object-cover object-left-top" />
            </div>
          </div>
        </div>

        {/* Bottom row — METAROOM + PARTNERS & CLIENTS (~30%) */}
        <div className="grid grid-cols-2 gap-3 flex-[1.2] min-h-0">
          {/* METAROOM */}
          <div className="flex flex-col min-h-0">
            <div className="text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] mb-1">
              <span className="text-[var(--color-fg)]">METAROOM</span>
              <span className="text-[var(--color-fg-tertiary)] font-normal ml-1.5">— AI Compliance Agent</span>
            </div>
            <div className="flex-1 min-h-0 rounded-sm border border-[var(--color-border)] bg-[var(--color-surface)] overflow-hidden p-2 flex flex-col justify-center gap-1 text-[8px]">
              {/* User message — right aligned */}
              <div className="flex items-center gap-1.5 justify-end">
                <div className="flex items-center gap-1 bg-[var(--color-border)] rounded px-1.5 py-0.5 opacity-70 shrink-0">
                  <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  <span className="text-[6px] text-[var(--color-fg-tertiary)]">Asia_Focus_VCC_Q1.pdf</span>
                </div>
                <div className="bg-[#818cf8]/20 border border-[#818cf8]/30 rounded px-2 py-1 text-[var(--color-fg-secondary)] leading-snug shrink-0">
                  Review for MAS advertising compliance
                </div>
                <div className="w-[12px] h-[12px] rounded-full bg-[#818cf8] shrink-0 flex items-center justify-center text-white text-[5px] font-bold">J</div>
              </div>
              {/* Agent reviewing */}
              <div className="flex items-center gap-1.5">
                <div className="w-[12px] h-[12px] rounded-full bg-[#10b981] shrink-0 flex items-center justify-center">
                  <svg width="6" height="6" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/></svg>
                </div>
                <div className="flex items-center gap-1 text-[var(--color-fg-tertiary)] italic">
                  <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
                  Reviewing against MAS regulations...
                </div>
              </div>
              {/* Agent response */}
              <div className="flex items-center gap-1.5">
                <div className="w-[12px] shrink-0" />
                <div className="bg-[var(--color-border)] rounded px-2 py-1 text-[var(--color-fg-secondary)] leading-snug shrink-0">
                  3 critical, 2 warnings, 8 passed.
                </div>
                <div className="flex items-center gap-1 bg-[var(--color-border)] rounded px-1.5 py-0.5 opacity-70 shrink-0">
                  <svg width="7" height="7" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                  <span className="text-[6px] text-[var(--color-fg-tertiary)]">Compliance_Review.pdf</span>
                </div>
              </div>
            </div>
          </div>

          {/* PARTNERS & CLIENTS */}
          <div className="flex flex-col min-h-0">
            <div className="text-[10px] font-[family-name:var(--font-mono)] font-bold uppercase tracking-[0.1em] text-[var(--color-fg)] mb-1">
              Partners &amp; Clients
            </div>
            <div className="flex-1 min-h-0 rounded-sm border border-[var(--color-border)] bg-[var(--color-surface)] flex items-center justify-center gap-4 px-3">
              {[
                { src: "/client-pvs.png", alt: "Premium Visa Solutions" },
                { src: "/client-turpinmiller.jpg", alt: "Turpin Miller" },
                { src: "/client-visapositive.jpg", alt: "Visa Positive" },
                { src: "/client-nara.png", alt: "Nara Solicitors" },
                { src: "/client-tannlaw.png", alt: "Tann Law Solicitors" },
              ].map((logo) => (
                <img key={logo.alt} src={logo.src} alt={logo.alt} className="h-[36px] w-auto object-contain opacity-70" />
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Three products live. <strong className="font-medium text-[var(--color-fg)]">Each one feeding the COSX engine.</strong>
        </p>
      </div>
    </div>
  );
}
